module.exports = __webpack_public_path__ + "img/ico_feed_luckyslot@3x.0e2bc5d4.png";